(function () {
  'use strict';

  // Safari "Alle Cookies blockieren" (und manche In-App-WebViews) werfen
  // bereits beim ZUGRIFF auf window.localStorage eine SecurityError — ein
  // einziger ungeschützter Zugriff killt das ganze Script und lässt die
  // Seite tot zurück. Fallback auf einen In-Memory-Store, damit die App
  // innerhalb der Sitzung weiter funktioniert.
  var localStore = (function () {
    try {
      var s = window.localStorage;
      s.setItem('__tt_probe', '1'); s.removeItem('__tt_probe');
      return s;
    } catch (e) {
      var mem = {};
      return {
        getItem: function (k) { return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; },
        setItem: function (k, v) { mem[k] = String(v); },
        removeItem: function (k) { delete mem[k]; }
      };
    }
  })();

  // ============================================================
  // KONFIGURATION
  // ============================================================
  var API_BASE = 'https://api.loopsubscriptions.com/storefront/2023-10';
  var SHOP_DOMAIN = 'tom-tasty.myshopify.com';
  // Keep the post-login redirect in the visitor's language (DE has no prefix,
  // EN/FR are served under /en and /fr) so EN/FR users land on the cockpit in
  // their language. Prefer Shopify's locale-aware root; fall back to the locale
  // segment already present in the current URL.
  function ttLocaleRoot() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r && r !== '/') return '/' + r.replace(/^\/+|\/+$/g, '');
    } catch (e) {}
    var m = (window.location.pathname || '').match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/)/i);
    return m ? '/' + m[1].toLowerCase() : '';
  }
  function localized(p) {
    if (!p || p.charAt(0) !== '/' || p.charAt(1) === '/') return p;
    return ttLocaleRoot() + p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
  }
  var COCKPIT_PATH = localized('/pages/cockpit');

  var STORAGE = {
    accessToken: 'loopAccessToken',
    refreshToken: 'loopRefreshToken',
    tokenExpiry: 'loop_portal_token_expiry',
  };

  // ============================================================
  // DOM REFS
  // ============================================================
  var root = document.getElementById('tt-loop-login');
  if (!root) return;

  var viewLogin = document.getElementById('tt-login-view');
  var viewRedirect = document.getElementById('tt-login-redirect');
  var form = document.getElementById('tt-login-form');
  var emailInput = document.getElementById('tt-login-email');
  var btn = document.getElementById('tt-login-btn');
  var btnText = document.getElementById('tt-login-btn-text');
  var btnLoading = document.getElementById('tt-login-btn-loading');
  var msgSuccess = document.getElementById('tt-login-msg-success');
  var msgError = document.getElementById('tt-login-msg-error');
  var msgExpired = document.getElementById('tt-login-msg-expired');

  function logAuth(event, detail) {
    try { console.log('[cockpit-auth]', event, detail || {}); } catch (e) { /* noop */ }
  }

  // Show the "session expired / please request a new link" banner. Triggered
  // either by an explicit ?reason= URL param (cockpit redirected here) or by
  // a magic-link exchange that returned non-2xx.
  function showExpiredBanner(reason) {
    if (msgExpired) msgExpired.style.display = 'flex';
    logAuth('expired_banner_shown', { reason: reason || 'unknown' });
  }

  // ============================================================
  // TOKEN MANAGEMENT
  // ============================================================

  function getTokens() {
    return {
      access: localStore.getItem(STORAGE.accessToken),
      refresh: localStore.getItem(STORAGE.refreshToken),
      expiry: localStore.getItem(STORAGE.tokenExpiry),
    };
  }

  function storeTokens(access, refresh) {
    localStore.setItem(STORAGE.accessToken, access);
    localStore.setItem(STORAGE.refreshToken, refresh);
    // A real customer magic-link login supersedes any prior admin impersonation.
    try { localStore.removeItem('tt_merchant_view'); } catch (e) {}
    var expiry = Date.now() + 4 * 24 * 60 * 60 * 1000; // 4 Tage
    localStore.setItem(STORAGE.tokenExpiry, expiry.toString());
  }

  function isLoggedIn() {
    var t = getTokens();
    if (!t.access || t.access === 'undefined') return false;
    // JWT exp prüfen
    try {
      var payload = JSON.parse(atob(t.access.split('.')[1]));
      if (payload.exp && payload.exp * 1000 < Date.now()) return false;
    } catch (e) {
      return false;
    }
    return true;
  }

  async function tryRefreshToken() {
    var t = getTokens();
    if (!t.refresh) return false;

    try {
      var res = await fetch(API_BASE + '/auth/accessToken', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: t.refresh }),
      });
      if (!res.ok) return false;
      var data = await res.json();
      if (data.data && data.data.accessToken) {
        localStore.setItem(STORAGE.accessToken, data.data.accessToken);
        var expiry = Date.now() + 4 * 24 * 60 * 60 * 1000;
        localStore.setItem(STORAGE.tokenExpiry, expiry.toString());
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  // ============================================================
  // SESSION TOKEN AUS URL (Magic Link Callback)
  // ============================================================

  async function handleMagicLinkCallback() {
    var params = new URLSearchParams(window.location.search);
    var sessionToken = params.get('sessionToken') || params.get('token');
    if (!sessionToken) return false;

    try {
      var res = await fetch(API_BASE + '/auth/refreshToken', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionToken: sessionToken }),
      });
      if (!res.ok) return false;
      var data = await res.json();
      storeTokens(data.data.accessToken, data.data.refreshToken);
      // URL säubern
      window.history.replaceState({}, '', window.location.pathname);
      return true;
    } catch (e) {
      return false;
    }
  }

  // ============================================================
  // REDIRECT
  // ============================================================

  function redirectToCockpit() {
    // Cockpit-URL aus data-Attribut oder Fallback
    var customUrl = root.getAttribute('data-cockpit-url');
    window.location.href = localized(customUrl || COCKPIT_PATH);
  }

  // ============================================================
  // UI HELPERS
  // ============================================================

  function showView(view) {
    viewLogin.style.display = view === 'login' ? '' : 'none';
    viewRedirect.style.display = view === 'redirect' ? '' : 'none';
  }

  function setLoading(on) {
    btn.disabled = on;
    btnText.style.display = on ? 'none' : '';
    btnLoading.style.display = on ? 'flex' : 'none';
  }

  function hideMessages() {
    msgSuccess.style.display = 'none';
    msgError.style.display = 'none';
  }

  // ============================================================
  // MAGIC LINK SENDEN
  // ============================================================

  async function sendMagicLink() {
    var email = emailInput.value.trim();
    if (!email) {
      emailInput.focus();
      return;
    }

    hideMessages();
    setLoading(true);

    try {
      var res = await fetch(API_BASE + '/auth/loginLink', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, myshopifyDomain: SHOP_DOMAIN }),
      });

      if (!res.ok) throw new Error('API ' + res.status);

      msgSuccess.style.display = 'flex';
      form.style.display = 'none';
    } catch (e) {
      console.error('Loop login error:', e);
      msgError.style.display = 'flex';
    } finally {
      setLoading(false);
    }
  }

  // ============================================================
  // EVENT LISTENERS
  // ============================================================

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      sendMagicLink();
    });
  }

  // ============================================================
  // INIT
  // ============================================================

  async function init() {
    showView('redirect'); // Zeige Spinner während wir prüfen

    var params = new URLSearchParams(window.location.search);
    var reason = params.get('reason');

    // 0. Merchant-Impersonation? Loops Admin ("Access customer portal") landet
    //    mit ?merchantToken=… hier auf der Login-Seite — einlösen kann den
    //    Token aber nur das Cockpit (tryUrlMerchantToken). Query 1:1
    //    weiterreichen, das Cockpit übernimmt Capture + URL-Bereinigung.
    if (params.get('merchantToken')) {
      logAuth('autologin', { source: 'merchant_token_forward' });
      window.location.replace(COCKPIT_PATH + window.location.search);
      return;
    }

    // 1. Magic Link Callback? (?sessionToken / ?token in URL)
    var hadUrlToken = !!(params.get('sessionToken') || params.get('token'));
    var fromMagicLink = await handleMagicLinkCallback();
    if (fromMagicLink) {
      logAuth('autologin', { source: 'url_session_token' });
      redirectToCockpit();
      return;
    }
    if (hadUrlToken && !fromMagicLink) {
      // Token was on the URL but Loop rejected it. Show the expired banner
      // on the form below so the user knows why they're back at login.
      reason = reason || 'session_expired';
    }

    // 2. Bereits eingeloggt (gültiger Token)?
    if (isLoggedIn()) {
      logAuth('autologin', { source: 'stored_access_token' });
      redirectToCockpit();
      return;
    }

    // 3. Token abgelaufen aber Refresh Token vorhanden?
    var refreshed = await tryRefreshToken();
    if (refreshed) {
      logAuth('autologin', { source: 'stored_refresh_token' });
      redirectToCockpit();
      return;
    }

    // 4. Nicht eingeloggt → Login-Formular zeigen. Banner nur bei einem
    //    bekannten Grund — ein nackter Login-Aufruf zeigt keinen Banner.
    if (reason === 'session_expired' || reason === 'refresh_expired') {
      showExpiredBanner(reason);
    } else {
      logAuth('fallback', { reason: reason || 'no_token' });
    }
    showView('login');
  }

  init();
})();
